module.exports = __webpack_public_path__ + "7e78447eecd1b13fe8d1ae4cf88331b4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logos/basic_h128.png
// module id = 316
// module chunks = 1